export * from './evo-commun-strings';
